import React from 'react';
import { useMediaQuery, useTheme } from '@material-ui/core';
import MobileProgressTracker from './MobileProgressTracker';
import DesktopProgressTracker from './DesktopProgressTracker';
import { ProgressTrackerProps } from '.';

const ProgressTracker = ({ steps }: ProgressTrackerProps) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  if (isMobile) {
    return <MobileProgressTracker steps={steps} />;
  }
  return <DesktopProgressTracker steps={steps} />;
};

export default ProgressTracker;
